/**
 * A2UI Button Component
 * Interactive button with action support
 */

import React from 'react';
import { Button } from 'react-bootstrap';

const variantMap = {
  'primary': 'primary',
  'secondary': 'secondary',
  'success': 'success',
  'danger': 'danger',
  'warning': 'warning',
  'info': 'info',
  'light': 'light',
  'dark': 'dark',
  'outline-primary': 'outline-primary',
  'outline-secondary': 'outline-secondary',
  'link': 'link',
};

const A2UIButton = ({ 
  child,
  label,
  action,
  variant = 'primary',
  disabled,
  style,
  resolveValue,
  renderChild,
  onAction,
  surfaceId,
  componentId
}) => {
  const handleClick = () => {
    if (action && onAction) {
      onAction({
        name: action.name,
        surfaceId,
        sourceComponentId: componentId,
        context: action.context,
        timestamp: new Date().toISOString()
      });
    }
  };

  const resolvedLabel = resolveValue ? resolveValue(label, surfaceId) : label?.literalString || '';
  const resolvedDisabled = resolveValue ? resolveValue(disabled, surfaceId) : disabled?.literalBoolean || false;
  const bootstrapVariant = variantMap[variant] || 'primary';

  return (
    <Button
      className="a2ui-button"
      variant={bootstrapVariant}
      disabled={resolvedDisabled}
      onClick={handleClick}
      style={style}
    >
      {child && renderChild ? renderChild(child) : resolvedLabel}
    </Button>
  );
};

export default A2UIButton;
